module.exports = __webpack_public_path__ + "assets/fe2fb7a6e1ec6c8b881f8f1cf8a6a69d.mp3";